
document.addEventListener('DOMContentLoaded', async() => {
  
let productForm = document.querySelector('.product-form-block .product-form');
async function embroideryProductAdd(){
    let personalize_input1 = document.getElementById('personalise__customInitial');
    // let personalize_input2 = document.getElementById('personalise__customcolor');
    // let personalize_input3 = document.getElementById('personalise__customfont');
    let personalise_initial_input = document.querySelector("#personalise_initial_input")
    // let personalise_initial_input2 = document.querySelector("#personalise_initial_input2")
  
    let embroideryVariantId = document.getElementById('embroidery-product').value;
  
    // Check if either input field is not empty
    if (personalize_input1.value !== '' && embroideryVariantId !== '') {
        let formData = {
         'items': [{
          'id': embroideryVariantId,
          'quantity': 1,
           "properties": {
             "_item_type":"Embroidery Product"
           }
          }],
          'note': 'embroidery',
          'attributes': {
           'note': 'embroidery'
          }
        };

        try {
          // Sending the POST request
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });

          const response2 = await window.fetch(`/cart?view=compare`);
          if (!response2.ok) {
            // FIXME: error handling
            return false;
          }
          const cart = await response2.json();
          // productForm.processResponse(response);
          window.wetheme.toggleRightDrawer('cart', true, {
            cart: cart
          });
          personalize_input1.value = '';
          // personalize_input2.value = '';
          personalise_initial_input.value = '';
          // personalise_initial_input2.value = '';
        } catch (error) {
          // Handle any errors
          console.error('Error:', error);
        }
    }
}

async function getPersonalisedItems() {
  try {
    // Fetch current cart data
    const response = await fetch('/cart.js');
    const data = await response.json();

    // Check for main product and embroidery product
    if (data['items'].length) {
      // Filter for main products: 
      const mainProducts = data['items'].filter(item => 
        item.properties && Object.keys(item.properties).length > 0 && // Check if properties is not an empty object
        (
          (item.properties['Initial'] && item.properties['Initial'] !== '')
        )
      );

      let embMainProductsQty = mainProducts.reduce((totalQty, product) => {
          return totalQty + Math.round(product.quantity);
      }, 0);
      
      console.log(mainProducts, "mainProducts");
      console.log(embMainProductsQty, "embMainProductsQty");
    
      // Filter for embroidery products:
      const embroideryProducts = data['items'].filter(item => 
        item.properties.hasOwnProperty('_item_type') && item.properties['_item_type'] !== ''
      );

      let embProQty =  embroideryProducts.reduce((totalQty, product) => {
          return totalQty + Math.round(product.quantity);
      }, 0);
      
      if(embProQty != embMainProductsQty && embroideryProducts.length != 0){
       updateProductQuantity(embroideryProducts[0].key, embMainProductsQty);
      }
    }
  } catch (error) {
    // Handle error if needed
    console.error('Error fetching cart data:', error);
  }
}

// Function to update product quantity in the cart with error handling using try-catch
async function updateProductQuantity(itemKey, newQuantity) {
  let cartLoader = document.querySelector('.right-drawer-vue .cart-loader-wrapper');
  try {
    
    (cartLoader && cartLoader.classList.add('cart-loader-visible'));
    // console.log(itemKey, "itemKey")
    let updates = {
      [itemKey]: newQuantity
    };

    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates }) // Send the updates object
    });

    
    if (!response.ok) {
      throw new Error(`Failed to update item quantity. Status: ${response.status}`);
    }
      const data = await response.json();
      
      // Filter for embroidery products:
      const embroideryProducts = data['items'].filter(item => 
        item.properties.hasOwnProperty('_item_type') && item.properties['_item_type'] !== ''
      );
    
        console.log(embroideryProducts, "embroideryProductsembroideryProducts")
      if(embroideryProducts.length === 0){
        remove_cart_notes(productForm, cartLoader);
        // console.log("No Embrodiery")
      }else{
        // productForm.processResponse(response);
        // window.wetheme?.updateCartDrawer(response);
          const response2 = await window.fetch(`/cart?view=compare`);
          if (!response2.ok) {
            // FIXME: error handling
            return false;
          }
          const cart = await response2.json();
          // productForm.processResponse(response);
          window.wetheme.toggleRightDrawer('cart', true, {
            cart: cart
          });
        
        (cartLoader && cartLoader.classList.remove('cart-loader-visible'));
      }
  } catch (error) {
    console.error("Error updating cart item:", error.message);
    (cartLoader && cartLoader.classList.remove('cart-loader-visible'));
  }
}

// Remove Cart Note if goft product not in the cart
let remove_cart_notes = async (productForm, cartLoader) => {
  try{
        let update_cart_notes = {
          note: '',
          attributes: {
            "note":''
          },
        }

        let update_note_in_cart =  await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(update_cart_notes)
        })

        if(!update_note_in_cart.ok){
          throw Error('Error Occur When Update Cart Note If Embrodiery product not in a cart');
        }
    
        // productForm.processResponse(update_note_in_cart);
        // window.wetheme?.updateCartDrawer(update_note_in_cart);
          const response2 = await window.fetch(`/cart?view=compare`);
          if (!response2.ok) {
            // FIXME: error handling
            return false;
          }
          const cart = await response2.json();
          // productForm.processResponse(response);
          window.wetheme.toggleRightDrawer('cart', true, {
            cart: cart
          });
    
       (cartLoader && cartLoader.classList.remove('cart-loader-visible'));    
  }catch(error){
    console.log(error)
  }                   
}  

  
  document.addEventListener('cart:item:change',getPersonalisedItems);
  // document.addEventListener('qty:change',getPersonalisedItems);
  document.addEventListener('embroidery:product:add', embroideryProductAdd);
  // document.addEventListener('wetheme-cart-update', () => {
  //    console.log('wetheme-cart-update')
  // });
});

